const t = new URL("../../assets/icon-goto-battle-pass-Dizfm7ca.png", import.meta.url).href;
export {
  t as default
};
//# sourceMappingURL=icon-goto-battle-pass.png.js.map
